import {createContext, use, useMemo} from 'react'
import type {PullRequestConfig} from '../types'

const defaultPullRequestConfig: PullRequestConfig = {enabled: true, canCreate: true}

const PullRequestConfigContext = createContext<PullRequestConfig>(defaultPullRequestConfig)

export function PullRequestConfigProvider({
  pullRequestConfig,
  children,
}: React.PropsWithChildren<{pullRequestConfig?: PullRequestConfig}>) {
  const value = useMemo(() => pullRequestConfig ?? defaultPullRequestConfig, [pullRequestConfig])
  return <PullRequestConfigContext value={value}>{children}</PullRequestConfigContext>
}

export function usePullRequestConfig() {
  return use(PullRequestConfigContext)
}
